module.exports = "<jhi-page-ribbon></jhi-page-ribbon> <router-outlet name=\"navbar\"></router-outlet> <div class=\"container-fluid main-container\" [ngStyle]=\"{'background-color':color}\"> <div class=\"card jh-card\"> <router-outlet></router-outlet> <router-outlet name=\"popup\"></router-outlet> </div> </div> <jhi-footer></jhi-footer> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/main/main.component.html
// module id = 1206
// module chunks = 0